import { render } from "./practiceHeader.vue?vue&type=template&id=947cdb46"
import script from "./practiceHeader.vue?vue&type=script&lang=js"
export * from "./practiceHeader.vue?vue&type=script&lang=js"

import "./practiceHeader.vue?vue&type=style&index=0&id=947cdb46&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__